module.exports = require("@liquality/wallet-provider");;